export default {
    title: 'Invite participants for trend evaluation',
    userIds: {
        label: 'Participants',
        placeholder: 'Select participants',
        error: 'Please select at least one participant | Please select at least {count} participants'
    },
    message: {
        label: 'Message',
        placeholder: 'Enter a message to the participants of the evaluation (optional).'
    },
    empty: 'There are no other users available for participation',
    submit: 'Send'
}
